import React, { Component } from 'react';
import PropsRoute from '../../../hoc/PropsRoute/PropsRoute';

import Auxi from '../../../hoc/Auxi/Auxi';
import IndexPage from '../../../containers/IndexPage/IndexPage';
import classes from './CreateAccount.module.css';
import strings from '../../../assets/localization';
import Modal from '../../UI/Modal/Modal';
import NavbarElement from '../../Navigation/Navbar/NavbarElement/NavbarElement';
import EmailRegisterContainer from '../../../containers/Auth/EmailRegister/EmailRegisterContainer';
import Spinner from '../../UI/Spinner/Spinner';
import Logo from '../../UI/Logo/Logo';
import LanguageSwitch from '../../../containers/LanguageSwitch/LanguageSwitchContainer';

export default class CreateAccount extends Component {
  renderSpinner = () => {
    return <div className={classes.SpinnerWrapper}><Spinner /></div>;
  }

  render () {
    const { step, isLandscape } = this.props;
    let stepTitle = strings.SignUp;
    if (!this.props.isLandscape) {
      stepTitle = <Logo small />;
    } else if (step === 1) {
      stepTitle = strings.gender;
    } else if (step === 2) {
      stepTitle = strings.location;
    } else if (step === 3) {
      stepTitle = strings.age;
    } else if (step === 4) {
      stepTitle = strings.username;
    } else if (step === 5) {
      stepTitle = strings.emailPassword;
    }

    return (
      <Auxi>
        {isLandscape ? <PropsRoute isLandscape={isLandscape} component={IndexPage} /> : null}
        <Modal
          navbarLeftElement={
            <NavbarElement
              fill='var(--svg-color-navigation-light)'
              imgIcon={step === 1 && isLandscape ? '/sprites.svg#icon-close-small' : '/sprites.svg#icon-arrow-left'}
              clicked={this.props.goBack}
            />
}
          navbarCenterElement={stepTitle}
          modalChildrenStyle={{ padding: 0 }}
          navbarRightElement={step === 1 && this.props.showLanguageSwitch && <LanguageSwitch />}
        >
          <EmailRegisterContainer
            isLandscape={this.props.isLandscape}
            step={this.props.step}
            goBack={this.props.goBack}
            goToStep={this.props.goToStep}
          />
          {this.props.showSpinner ? this.renderSpinner() : null}
        </Modal>
      </Auxi>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Auth/CreateAccount/CreateAccount.js